import { Component, Input, OnInit } from '@angular/core';
import { SlideInOutAnimation } from './animation';

@Component({
  selector: 'app-create-carrier-notification',
  templateUrl: './create-success.component.html',
  styleUrls: ['./create-success.component.scss'],
  animations: [SlideInOutAnimation],
  standalone: false,
})
export class CreateSuccessComponent implements OnInit {
  @Input() notificationText: string;
  @Input() notificationState: string;

  constructor() {}

  ngOnInit(): void {}

  close(): void {
    this.notificationState = 'out';
  }
}
